import type { ChannelKeyName, MetricKeyNames, SegmentId } from "app/constants/MmxChannels";
import { CHANNEL_KEY_NAMES } from "app/constants/MmxChannels";

import type { Granularities } from "./MMXCommon";

export type SegmentMetricDisplayKey = "Value" | "Percentage";

export type ISegmentsMMXDataPoint = Record<SegmentMetricDisplayKey, number> & {
    Confidence: number;
};

interface IBreakdownItem {
    Key: string;
    Value: ISegmentsMMXDataPoint;
}

export interface ISegmentsMMXGraphSingleChannelData {
    Breakdown: IBreakdownItem[];
    Total: ISegmentsMMXDataPoint;
}

type ISegmentsMMXGraphChannelsData = Record<ChannelKeyName, ISegmentsMMXGraphSingleChannelData>;
type ISegmentsMMXGraphChartEngagementVerticals = Record<MetricKeyNames, ISegmentsMMXGraphChannelsData>;
type ISegmentsMMXGraphSegmentData = Record<Granularities, ISegmentsMMXGraphChartEngagementVerticals> & {
    Meta?: {
        SegmentShare?: number;
    };
};

export interface ISegmentsMMXGraphData {
    [segmentId: SegmentId]: ISegmentsMMXGraphSegmentData;
}

export interface ISegmentsMMXBarChartData {
    id: SegmentId;
    channel: ChannelKeyName;
    value: number;
    confidence: number;
}

export const transformGraphMMXDataToBarChartData = (
    graphData: ISegmentsMMXGraphData,
    segmentId: SegmentId,
): ISegmentsMMXBarChartData[] => {
    return CHANNEL_KEY_NAMES.map((channel) => {
        const dataPoint = graphData?.[segmentId]?.Monthly?.Visits?.[channel]?.Total;
        return {
            id: segmentId,
            channel,
            value: dataPoint?.Value ?? 0,
            confidence: dataPoint?.Confidence ?? 0,
        };
    });
};
